
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 8.5C15.44 8.5 8.5 15.443 8.5 24c0 8.562 6.94 15.5 15.5 15.5 8.56 0 15.5-6.938 15.5-15.5 0-8.557-6.94-15.5-15.5-15.5zm0 6.875a2.625 2.625 0 110 5.25 2.625 2.625 0 010-5.25zm3.5 15.875a.75.75 0 01-.75.75h-5.5a.75.75 0 01-.75-.75v-1.5a.75.75 0 01.75-.75H22v-4h-.75a.75.75 0 01-.75-.75v-1.5a.75.75 0 01.75-.75h4a.75.75 0 01.75.75V29h.75a.75.75 0 01.75.75v1.5z","fill":"#535353"}})])
          )
        }
      }
    